import { useEffect } from 'react';

/**
 * Met à jour le <title> et la <meta name="description"> de la page courante.
 * À appeler en haut d'un composant page (ex: Home.tsx, PublicMenu.tsx).
 *
 * Au unmount, on ne restaure rien — la prochaine page set son propre title.
 *
 * Note : pour le SEO côté Google, l'index.html contient un title et une
 * description par défaut. Ce hook les surcharge à la navigation.
 */
export function useDocumentMeta(meta: { title?: string; description?: string }) {
  useEffect(() => {
    if (meta.title) {
      document.title = meta.title;
    }
    if (meta.description) {
      let tag = document.querySelector<HTMLMetaElement>(
        'meta[name="description"]'
      );
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', meta.description);
    }
  }, [meta.title, meta.description]);
}
